import React from 'react'

const ViewSiniesterIncome = () => {
  return (
    <>
      <img src="" alt="Logo EY" />
    </>
  )
}

export default ViewSiniesterIncome